<div class="table-responsive" *ngIf="guardian.students.length>0">
    <table datatable [dtOptions]="dtOptions" class="table table-striped display compact" id="assetTable">
        <tr><td>Name</td><td> Study Material</td></tr>
<tr *ngFor="let student of guardian.students; index as myCount">
   <td><i class="fa fa-graduation-cap text-secondary"></i> {{student.fullname}}</td>
   <td> <a [routerLink]="['/study/material/index/',server_user_id,student.server_user_id]"><i class="fa fa-book"></i> </a></td>
</tr>
</table>
</div>


